<template>
  <div class="container">
    <LineChart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"
      class="graph"/>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'CsatChartClient',
  components: { LineChart },
   data() {
   return {
    loaded: true, 
    chartdata: {
      labels: ['January', 'February', 'March'],
      datasets: [
        {
          label: 'Customer Effort Score',
          borderColor: "rgba(56, 80, 104, 0.8)",
          pointBackgroundColor: "rgba(171, 71, 188, 1)",
          data: [4, 7, 5]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
   }
   }
// -------------------- Chart with API data --------------------- //
//   data: () => ({
//     loaded: false,
//     chartdata: null
//   }),
//   async mounted () {
//     this.loaded = false
//     try {
//       const { userlist } = await fetch('/api/userlist')
//       this.chartdata = userlist
//       this.loaded = true
//     } catch (e) {
//       console.error(e)
//     }
//   }
}
</script>